import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';

import { AccountService } from 'src/app/core/services/account.service';
import { CountryDto, UserAccountAddressDto, UserAddressDto } from '../../../core/dtos/dto';
import { CountryRegionService } from 'src/app/core/services/country-region.service';
import { AddressFormData } from 'src/app/core/dtos/address-form-data';
import { forkJoin } from 'rxjs';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';

@Component({
  selector: 'app-edit-address',
  templateUrl: './edit-address.component.html',
  styleUrls: ['./edit-address.component.scss']
})
export class EditAddressComponent implements OnInit {

  userAddress: UserAccountAddressDto;
  countries: CountryDto[];
  areShippingBillingAddressSame: boolean;

  billingAddressFormData: AddressFormData;
  shippingAddressFormData: AddressFormData;
  isBillingFormValid = false;
  isShippingFormValid = false;
  submitted = false;

  constructor(
    private accountService: AccountService,
    private toastService: HotToastService,
    private countryService: CountryRegionService,
  ) { }

  ngOnInit(): void {
    this.getAddress();
  }

  billingFormValueChanged(formData: AddressFormData) {
    this.billingAddressFormData = formData;
  }

  shippingFormValueChanged(formData: AddressFormData) {
    this.shippingAddressFormData = formData;
  }

  getAddress() {
    forkJoin([this.accountService.getAddress(), this.countryService.getCountries()])
      .subscribe(
        result => {
          this.userAddress = result[0].content;
          this.countries = result[1].content;
          this.countries = this.countries.filter(x => x.name !== "IRAN (ISLAMIC REPUBLIC OF)");
        },
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            this.toastService.warning("Unable to load page.");
          }
        });
  }

  onSubmit() {
    this.submitted = true;

    let address: UserAccountAddressDto = null;
    let canSave = false;

    if (this.userAddress.areShippingBillingAddressSame && this.shippingAddressFormData?.isValid) {
      address = this.setAddresses(this.shippingAddressFormData.address, this.shippingAddressFormData.address);
      canSave = true;
    } else if (this.billingAddressFormData?.isValid && this.shippingAddressFormData?.isValid) {
      address = this.setAddresses(this.billingAddressFormData.address, this.shippingAddressFormData.address);
      canSave = true;
    }

    if (canSave) {
      this.accountService.editAddress(address)
        .subscribe(
          () => {
            this.toastService.success("Saved.");
          },
          (error: HttpErrorResponse) => {
            if (error.status !== 401) {
              const errorMessage = error.error as HttpErrorResponseMessages;
              if (errorMessage?.reasons) {
                errorMessage.reasons.forEach(reasons => {
                  this.toastService.warning(reasons.errorMessage);
                });
              }
              else {
                this.toastService.warning("Failed to save address information because of unknown problem. Please contact Paragon.");
              }
            }
          });
    } else {
      this.toastService.warning("Please fill in the missing fields");
    }
  }

  setAddresses(billingAddress: UserAddressDto, shippingAddress: UserAddressDto) {
    const newAddress: UserAccountAddressDto = {
      billingAddress: { ...billingAddress, fullName: this.userAddress.shippingAddress.fullName },
      shippingAddress: { ...shippingAddress, fullName: this.userAddress.shippingAddress.fullName },
      areShippingBillingAddressSame: this.userAddress.areShippingBillingAddressSame
    };
    return newAddress;
  }

}
